if (!customElements.get('twa-announcement')) {
  customElements.define('twa-announcement', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.pause = this.querySelector('[data-ann-pause]');
      this.pause.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        this.pause.textContent = paused ? 'Play' : 'Pause';
        this.pause.setAttribute('aria-pressed', String(paused));
        this.pause.setAttribute('aria-label', paused ? 'Resume scrolling announcement' : 'Pause scrolling announcement');
      }, { signal });
      this.querySelector('[data-ann-close]')?.addEventListener('click', () => {
        this.hidden = true;
        this.stop();
      }, { signal });
      this.motion.addEventListener('change', () => this.layout(), { signal });
      this.observer = new ResizeObserver(() => this.layout());
      this.observer.observe(this.querySelector('.twa-ann__viewport'));
      document.fonts.ready.then(() => { if (this.isConnected) this.layout(); });
      this.layout();
      this.startCountdown();
    }

    layout() {
      this.querySelectorAll('[data-ann-clone]').forEach(node => node.remove());
      this.removeAttribute('data-animated');
      const animated = this.dataset.scroll === 'true' && !this.motion.matches;
      this.pause.hidden = !animated;
      if (!animated || this.hidden) return;
      this.setAttribute('data-animated', '');
      const viewport = this.querySelector('.twa-ann__viewport');
      const group = this.querySelector('.twa-ann__group');
      const source = group.firstElementChild;
      const width = source.getBoundingClientRect().width;
      if (!width) return;
      const clone = node => {
        const copy = node.cloneNode(true);
        copy.setAttribute('data-ann-clone', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.inert = true;
        return copy;
      };
      const repeats = Math.min(30, Math.ceil(viewport.clientWidth / width));
      for (let i = 1; i < repeats; i++) group.append(clone(source));
      group.parentElement.append(clone(group));
    }

    startCountdown() {
      clearInterval(this.interval);
      const deadline = this.dataset.deadline?.trim();
      this.querySelector('.twa-ann__countdown').hidden = true;
      const validation = this.querySelector('[data-ann-validation]');
      if (validation) validation.hidden = true;
      // An explicit offset prevents each visitor interpreting the deadline locally.
      if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(deadline || '')) return;
      const end = Date.parse(deadline);
      const parts = deadline.slice(0, 19).split(/[-T:]/).map(Number);
      const calendarDate = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]));
      if (!Number.isFinite(end) || !Number.isFinite(calendarDate.getTime()) || calendarDate.toISOString().slice(0, 19) !== deadline.slice(0, 19)) {
        if (validation) validation.hidden = false;
        return;
      }
      const timer = this.querySelector('[data-ann-time]');
      timer.dateTime = deadline;
      this.querySelector('.twa-ann__countdown').hidden = false;
      const update = () => {
        const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        if (!remaining) {
          if (this.dataset.expiry === 'hide') this.hidden = true;
          else {
            this.querySelector('[data-ann-content]').hidden = true;
            this.querySelector('[data-ann-ended]').hidden = false;
          }
          this.stop();
          return;
        }
        const days = Math.floor(remaining / 86400);
        const hours = Math.floor(remaining % 86400 / 3600);
        const minutes = Math.floor(remaining % 3600 / 60);
        const seconds = remaining % 60;
        timer.textContent = `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
        timer.setAttribute('aria-label', `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`);
      };
      this.interval = setInterval(update, 1000);
      update();
    }

    stop() {
      clearInterval(this.interval);
      this.observer?.disconnect();
    }

    disconnectedCallback() {
      this.stop();
      this.controller?.abort();
    }
  });
}
